import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { AuthCredentialsForm } from "@/components/auth/AuthCredentialsForm";
import { AuthSocialButtons } from "@/components/auth/AuthSocialButtons";
import useFacebookLogin from "@/components/auth/useFacebookLogin";
import { ForgotPasswordForm } from "@/components/auth/ForgotPasswordForm";

const COPY = {
  login: { title: "Sign in to BIGA", desc: "Sign in to track your BIGA orders.", heading: "Welcome back", sub: "Sign in to track your orders.", done: "Welcome back!" },
  register: { title: "Create your BIGA account", desc: "Create an account to save and reorder your BIGA orders.", heading: "Join BIGA", sub: "Save your orders & reorder in one tap.", done: "Account created — buon appetito!" },
  forgot: { title: "Reset your BIGA password", desc: "Get a password reset link by email.", heading: "Forgot password?", sub: "We'll email you a reset link." },
};

export default function AuthModal({ open, onOpenChange, onSuccess, defaultMode, prefill }) {
  const { login, register, adoptSession } = useAuth();
  const [mode, setMode] = useState(defaultMode || "login");
  const [form, setForm] = useState({ name: prefill?.name || "", email: prefill?.email || "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const finish = () => { onOpenChange(false); onSuccess?.(); };
  const { facebook, signIn } = useFacebookLogin((user) => { adoptSession(user); toast.success(`Welcome, ${user.name.split(" ")[0]}!`); finish(); });
  useEffect(() => { if (defaultMode) setMode(defaultMode); }, [defaultMode]);
  useEffect(() => { if (prefill) setForm((c) => ({ ...c, name: prefill.name || c.name, email: prefill.email || c.email })); }, [prefill]);

  const submit = async (event) => {
    event.preventDefault(); setError(""); setLoading(true);
    const result = mode === "login" ? await login(form.email, form.password) : await register(form.name, form.email, form.password,
      form.bday_day && form.bday_month ? { birthday_day: Number(form.bday_day), birthday_month: Number(form.bday_month) } : {});
    setLoading(false);
    if (result.ok) { toast.success(COPY[mode].done); finish(); } else setError(result.error);
  };
  const copy = COPY[mode];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="p-0 border-2 border-biga-ink rounded-3xl overflow-hidden max-w-md bg-biga-cream" data-testid="auth-modal">
        <DialogTitle className="sr-only">{copy.title}</DialogTitle>
        <DialogDescription className="sr-only">{copy.desc}</DialogDescription>
        <div className="bg-biga-orange px-7 py-6">
          <h2 className="font-display font-black text-3xl text-biga-cream leading-none">{copy.heading}</h2>
          <p className="text-biga-cream/90 text-sm mt-1 font-medium">{copy.sub}</p>
        </div>
        {mode === "forgot" ? <ForgotPasswordForm initialEmail={form.email} onBack={() => { setMode("login"); setError(""); }} /> : <>
        <div className="px-7 pt-6 space-y-3"><AuthSocialButtons facebook={facebook} onFacebook={signIn} /></div>
        <AuthCredentialsForm mode={mode} form={form} error={error} loading={loading} onForgot={() => setMode("forgot")}
          onFieldChange={(field) => (event) => setForm((f) => ({ ...f, [field]: event.target.value }))}
          onSubmit={submit} onModeChange={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }} />
        </>}
      </DialogContent>
    </Dialog>
  );
}
